export default {
  app: {
    privacy: {
      policy: 'privacybeleid',
      expansive: 'Door Expansive te gebruiken, ga je akkoord met de Expansive {action}',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Sessie verlopen',
    sessionExpiredDescription:
      'Je sessie is verlopen. Log opnieuw in om de applicatie te blijven gebruiken.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Kies taal',
      chooseLanguageDescription:
        'Kies je voorkeurstaal voor de applicatie. Dit verandert de taal van de interface en inhoud.',
    },
    userSelection: {
      cancel: 'Annuleren',
      createNewUser: 'Hun naam staat er niet bij',
      newUser: 'Nieuwe gebruiker',
      selectAnExistingUser: 'Selecteer een bestaande gebruiker',
      selectUserHint: 'Selecteer een bestaande gebruiker of maak een nieuwe aan om verder te gaan.',
      startTypingToSearch: 'Begin met typen...',
    },
    verification: {
      codeVerification: {
        continue: 'Doorgaan',
        header: 'Voer site toegangscode in',
        invalidCode: 'Ongeldige code, probeer het opnieuw.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Doorgaan zonder locatie te verifiëren',
        enterSiteAccessCode: 'Voer site toegangscode in',
        locationNotEnabledOrAvailable: 'Waarom zie ik dit?',
        notAvailable: {
          description: 'GPS-locatie wordt niet ondersteund op dit apparaat.',
          header: 'Locatie niet ondersteund',
        },
        notEnabled: {
          description: 'Locatieservices zijn niet ingeschakeld of toestemming is niet verleend.',
          header: 'Locatie niet ingeschakeld',
        },
        notVerified: {
          description: 'GPS geeft aan dat je niet op locatie bent.',
          header: 'Locatie niet geverifieerd',
        },
        tryAgain: 'Opnieuw proberen',
        unavailable: {
          description: 'We konden je GPS-locatie niet verifiëren.',
          header: 'Locatie niet beschikbaar',
        },
        unknown: {
          description: 'We kunnen je locatie niet bepalen.',
          header: 'Locatie onbekend',
        },
        verified: {
          description: 'GPS geeft aan dat je op locatie bent.',
          header: 'Locatie geverifieerd',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Geen assets gevonden',
        emptyDescription: 'Er zijn geen assets gekoppeld aan deze werkbon.',
        warrantyParts: 'Garantie onderdelen verloopt',
        serialNumber: 'Serienummer',
        none: '<geen>',
      },
      updates: {
        emptyTitle: 'Geen updates gevonden',
        emptyDescription: 'Er zijn geen updates voor deze werkbon.',
        unknownUser: 'Onbekende gebruiker',
        none: 'Geen',
        addComment: {
          buttonLabel: 'Opmerking toevoegen',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Gevaren',
          no: 'Nee',
          yes: 'Ja',
        },
      },
    },
    attachmentsList: {
      attachments: 'Bijlagen',
      documents: 'Documenten',
      siteDocuments: 'Locatiedocumenten',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Gevaren',
        induction: 'Introductie',
        safeToProceed: 'Veilig om door te gaan',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Vervaldatum',
        activeSessions: 'Actieve sessies',
        activeSessionsDescription:
          'Je bent al ingecheckt bij de volgende werkbonnen. Je moet uitchecken voordat je bij een nieuwe werkbon kunt inchecken.',
        resumeSession: 'Hervatten',
        startTime: 'Gestart om',
        unexpectedErrorTitle: 'Onverwachte fout',
        unexpectedErrorMessage:
          'Er is een onverwachte fout opgetreden bij het aanmaken van je sessies. Probeer het later opnieuw.',
        engineerNotFound: 'Monteur niet gevonden',
        engineerNotFoundDescription:
          'De monteur die je probeert in te checken is niet gevonden in het systeem. Neem contact op met je beheerder.',
      },
      verification: {
        code: {
          description:
            'Om in te checken, vraag de 4-cijferige code aan de sitebeheerder of contactpersoon.',
        },
        geo: {
          continue: 'Doorgaan',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Vraag de toegangscode op bij de locatiemanager of aangewezen contactpersoon om uw bezoek af te ronden.',
            checkOut: 'Uitchecken',
            completeBeforeLeaving: 'Vul het volgende formulier in voordat je vertrekt.',
            continue: 'Doorgaan',
            noResolutionSelected: 'Selecteer een oplossing voordat je doorgaat.',
            quoteRequired: {
              hint: 'Bezoek voltooid, offerte volgt',
              label: 'Offerte vereist',
            },
            returnVisitRequired: {
              hint: 'We komen terug om af te ronden',
              label: 'Herhaalbezoek vereist',
            },
            serviceCompleted: {
              hint: 'Geen verdere actie vereist',
              label: 'Service voltooid',
            },
            uploadCheckout: 'Upload een bestand, foto of video',
            visitNotes: 'Bezoeknotities',
            workOrderResolution: 'Werkbonoplossing',
            enterNotes: 'Voer hier notities in...',
            errors: {
              timedOut:
                'Time-out, meer dan 30 seconden verstreken. Probeer het alstublieft opnieuw.',
              closingSession: 'Fout bij sluiten sessie',
            },
          },
          success: {
            description:
              'Bedankt voor je bezoek aan {site}. | {site} heeft nog 1 openstaande werkbon. | {site} heeft nog {count} openstaande werkbonnen.',
            endVisit: 'Bezoek beëindigen',
            header: 'Je bent succesvol uitgecheckt',
            viewWorkOrders: 'Check in bij een andere werkbon',
          },
          verification: {
            code: {
              description:
                'Om uit te checken, vraag de 4-cijferige code aan de sitebeheerder of contactpersoon.',
              continue: 'Doorgaan',
            },
            geo: {
              checkOut: 'Uitchecken',
              continue: 'Doorgaan',
            },
          },
        },
        detail: {
          assets: 'Assets',
          call: 'Bellen',
          checkOut: 'Uitchecken',
          closed: 'Gesloten',
          details: 'Details',
          dueBy: 'Vervaldatum',
          manageEngineers: 'Monteurs beheren',
          notAvailable: 'Niet beschikbaar',
          pointOfContact: 'Contactpersoon',
          siteAccessTimes: 'Toegangstijden locatie',
          siteAccessInstructions: 'Toegangsinstructies',
          siteAddress: 'Locatieadres',
          siteNotes: 'Locatienotities',
          siteTelephone: 'Locatietelefoon',
          siteLocation: 'Locatie',
          updates: 'Updates',
          more: 'Meer',
          mismatchErrorTitle: 'Werkbonfout',
          mismatchErrorMessage:
            'De werkbon die je probeert te openen komt niet overeen met de werkbon waar je nu bent ingecheckt. Controleer je werkbon en probeer het opnieuw.',
          siteDocuments: 'Locatiedocumenten',
          validFrom: 'Geldig vanaf',
          validUntil: 'Geldig tot',
          documentName: 'Documentnaam',
          documentType: 'Documenttype',
          attachments: 'Werkbonbestanden',
          download: 'Downloaden',
          workDetails: 'Werkdetails',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Assistent-monteur toevoegen',
            assistantEngineers: 'Assistent-monteurs',
            description: 'Vul om veiligheidsredenen de namen van alle monteurs op locatie in.',
            editMainEngineer: 'Hoofdmonteur bewerken',
            errors: {
              creatingEngineer: 'Fout bij aanmaken monteur',
              creatingSession: 'Fout bij aanmaken sessie',
            },
            header: 'Monteurs op locatie',
            mainEngineer: 'Hoofdmonteur',
            newAssistantEngineer: 'Voer hun volledige naam in',
            next: 'Volgende',
            removeEngineer: 'Monteur verwijderen',
            selectExistingAssistantEngineer: 'Begin met hun naam te typen',
          },
          index: {
            description: 'Vul om veiligheidsredenen de namen van alle monteurs op locatie in.',
            errorCreatingEngineer: 'Fout bij aanmaken monteur, probeer het opnieuw.',
            header: 'Monteurs op locatie',
            hintMainEngineer: 'Voer de volledige naam van de hoofdmonteur in',
            newMainEngineer: 'Nieuwe hoofdmonteur',
            next: 'Volgende',
            selectExistingMainEngineer: 'Selecteer een bestaande hoofdmonteur',
            yes: 'Ja',
            no: 'Nee',
            mainEngineerLabel: 'Ben jij de hoofdmonteur?',
          },
        },
        index: {
          callUsOn: 'Bel ons op {phoneNumber}',
          description: 'Kun je niet vinden wat je zoekt?',
          dueBy: 'Vervaldatum',
          header: 'Selecteer werkbon',
          notAvailable: 'Niet beschikbaar',
          searchWorkOrders: 'Zoek werkbonnen...',
        },
        manageEngineers: {
          manageEngineers: 'Monteurs beheren',
          notWorking: 'Inactieve medewerkers',
          pause: 'Pauzeren',
          resume: 'Hervatten',
          workingNow: 'Actieve medewerkers',
          startTime: 'Starttijd',
          endTime: 'Eindtijd',
          duration: 'Duur',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Feedback',
            feedbackDescription: 'Geef feedback over de werkbon om onze diensten te verbeteren.',
            feedbackLabel: 'Feedback',
            filesLabel: 'Bijlagen',
            submissionLabel: 'Feedback versturen',
          },
          hazards: {
            back: 'Ga terug',
            hazards: 'Gevaren',
            next: 'Volgende',
            no: 'Nee',
            noTasksForHazard: 'Er zijn geen taken voor dit gevaar.',
            yes: 'Ja',
          },
          induction: {
            continue: 'Doorgaan',
            induction: 'Introductie',
          },
          index: {
            checkIn: 'Inchecken',
            description: 'Vul de volgende risico-inventarisatie in voor het geselecteerde werk.',
            fail: 'Start werkbon controles verwerken mislukt.',
            haltMessage:
              "Potentiële risico's gedetecteerd. Stop het werk, bekijk de veiligheidsrichtlijnen en neem contact op met je leidinggevende voor verdere instructies.",
            header: 'Start werk controles',
            endVisit: 'Bezoek beëindigen',
            leaveFeedback: 'Feedback achterlaten',
          },
          safeToProceed: {
            continue: 'Doorgaan',
            safeToProceed: 'Veilig om door te gaan',
          },
        },
      },
    },
    index: {
      title: 'Welkom',
      description: 'Scan de QR-code op je locatie om te beginnen.',
    },
    login: {
      errorTitle: 'Onverwachte fout',
      errorMessage: 'Er is een onverwachte fout opgetreden. Scan de QR-code opnieuw.',
    },
    unauthenticated: {
      welcome: {
        title: 'Welkom bij {site}',
        description:
          'Voordat we werkbonnen kunnen tonen, moeten we je gegevens verifiëren. Klik op de knop hieronder om verder te gaan.',
        next: 'Doorgaan',
      },
      index: {
        errorTitle: 'Onverwachte fout',
        errorMessage: 'Er is een onverwachte fout opgetreden. Scan de QR-code opnieuw.',
      },
      contractor: {
        title: 'Voor wie werk je?',
        contractor: 'Aannemer',
        contractorLabel: 'Begin met het typen van je bedrijfsnaam',
        contractorHint: 'Voer minimaal 3 tekens in om resultaten te zien',
        defaultSelectPlaceholder: '--Selecteer--',
        next: 'Volgende',
      },
      user: {
        title: 'Wie ben je?',
        cancel: 'Annuleren',
        createNewUserLabel: 'Mijn naam staat er niet bij',
        existingUserLabel: 'Begin met het typen van je naam',
        existingUserHint: 'Voer minimaal 3 tekens in om resultaten te zien',
        newUserLabel: 'Voer je volledige naam in',
        next: 'Volgende',
        user: 'Gebruiker',
      },
      verification: {
        methods: {
          add: {
            add: 'Verificatiemethode toevoegen',
            defaultSelectPlaceholder: '--Selecteer--',
            emailLabel: 'E-mail',
            existingMethodWarning:
              'Je hebt al een lopend verzoek voor deze verificatiemethode in afwachting van goedkeuring door de beheerder. Een nieuwe toevoegen zal deze overschrijven.',
            method: 'Methode',
            methodLabel: 'Methode',
            mobileCountryHint: 'Selecteer je landcode',
            mobileCountryLabel: 'Mobiele landcode',
            mobileHint: 'Voer je mobiele nummer in',
            mobileLabel: 'Mobiel',
            title: 'Verificatiemethode toevoegen',
          },
          confirm: {
            confirm: 'Bevestigen',
            description: 'Bevestig je verificatiemethode om verder te gaan.',
            label: 'Voer je code in',
            resend: 'Opnieuw verzenden',
            resendPrompt: 'Geen code ontvangen?',
            title: 'Verificatiemethode bevestigen',
          },
          confirmed: {
            description:
              'Je ontvangt een melding zodra deze verificatiemethode is goedgekeurd door je beheerder. Daarna kun je deze gebruiken om je identiteit te verifiëren.',
            forceApproval: 'Totdat het is goedgekeurd, heb je geen toegang tot werkbonnen.',
            nonForceApproval:
              'In de tussentijd kun je werkbonnen blijven bekijken met beperkte toegang.',
            nonForceApprovalButtonLabel: 'Doorgaan met beperkte toegang',
            title: 'In afwachting van goedkeuring',
          },
          addNew: 'Nieuwe verificatiemethode toevoegen',
          description:
            'We moeten je identiteit verifiëren om je volledige toegang tot de werkbon te geven.',
          email: 'E-mail',
          hint: 'We sturen een link naar je geselecteerde verificatiemethode waarmee je volledige toegang krijgt tot de werkbon. Wil je bestaande methoden wijzigen, neem dan contact op met je beheerder.',
          label: 'Selecteer een verificatiemethode',
          next: 'Volgende',
          pendingHint: 'In afwachting van goedkeuring door je beheerder',
          sms: 'SMS',
          title: 'Verificatie',
        },
        optional: {
          hint: 'Door je gebruikersgegevens te verifiëren krijg je volledige toegang tot de werkbon',
          label: 'Wil je je gebruikersgegevens verifiëren?',
          next: 'Volgende',
          no: 'Nee',
          noHint:
            'Ik wil mijn gebruikersgegevens niet verifiëren en doorgaan met beperkte toegang tot de werkbon',
          title: 'Verificatie',
          yes: 'Ja',
          yesHint: 'Ik wil mijn gebruikersgegevens verifiëren en volledige toegang tot de werkbon',
        },
        sent: {
          description:
            'Er is een inloglink gestuurd naar {identifier}. Klik op de link om je in te loggen.',
          title: 'Inloglink verzonden',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Gisteren',
      today: 'Vandaag',
      days: {
        monday: 'Maandag',
        tuesday: 'Dinsdag',
        wednesday: 'Woensdag',
        thursday: 'Donderdag',
        friday: 'Vrijdag',
        saturday: 'Zaterdag',
        sunday: 'Zondag',
      },
      months: {
        january: 'Januari',
        february: 'Februari',
        march: 'Maart',
        april: 'April',
        may: 'Mei',
        june: 'Juni',
        july: 'Juli',
        august: 'Augustus',
        september: 'September',
        october: 'Oktober',
        november: 'November',
        december: 'December',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Er is iets misgegaan',
      message: 'Scan de QR-code opnieuw.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Onbekende gebruiker',
      },
      none: 'Geen',
      types: {
        stateTransition: 'Status gewijzigd',
        contractorAssigned: 'Aannemer toegewezen',
        engineerAssigned: 'Monteur toegewezen',
        serviceAssigned: 'Service toegewezen',
        priorityChanged: 'Prioriteit gewijzigd',
        actionableDateChanged: 'Actiedatum gewijzigd',
        dueDateChanged: 'Vervaldatum gewijzigd',
        etaDateChanged: 'Verwachte aankomsttijd gewijzigd',
        spendLimitApproved: 'Bestedingslimiet goedgekeurd',
        spendLimitCancelled: 'Verzoek bestedingslimiet geannuleerd',
        spendLimitRejected: 'Bestedingslimiet afgewezen',
        spendLimitRequested: 'Bestedingslimiet aangevraagd',
        jobSheetUploaded: 'Werkbon geüpload',
        slaAlertSent: 'SLA-waarschuwing tijd overschreden',
        issuedWorkPermit: 'Werkvergunning uitgegeven',
        requestForServiceSent: 'Serviceverzoek verzonden',
        comment: 'Opmerking toegevoegd',
        unknown: 'Onbekend evenement',
      },
      labels: {
        actionableDate: 'Actiedatum',
        comment: 'Opmerking',
        file: 'Bestand',
        contractor: 'Aannemer',
        dueDate: 'Vervaldatum',
        etaDate: 'Verwachte aankomsttijd',
        engineer: 'Monteur',
        priority: 'Prioriteit',
        requestForService: 'Serviceverzoek',
        service: 'Service',
        spendLimit: 'Bestedingslimiet',
        status: 'Status',
        workPermit: 'Werkvergunning',
      },
    },
  },
}
